export default __webpack_public_path__ + "static/media/pin.6cb3d55d.svg";